import { ThemeProvider, createTheme } from '@mui/material/styles';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#122D45',
      light: '#194972ff',
      dark: 'rgba(6,20,35,0.75)'
    },
    secondary: {
      main: '#10b981',
      light: "#34d399",
      dark: "#10b981",
      contrastText: "#022c22"
    },
    grey: {
      "100": "#646464"
    },
    error: {
      main: "#B00020",
      light: "#FF6F61"
    }
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
  spacing: 8,
  typography: {
    fontFamily: '"Poppins", sans-serif',
    fontSize: 14,
  },
});

const container = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  // HTML déjà pré-rendu par react-snap → on hydrate
  hydrateRoot(container, app);
} else {
  // Rendu classique (dev local, ou pas de pré-rendu)
  createRoot(container).render(app);
}